const DEFAULT_LOCALE_CODE = 'en-US';
const GOLD_COMPANY_ID = '00000000-0000-0000-0000-000000000000';
const GOLD_COPY_NOT_AVAILABLE_TEXT = 'Gold Copy is not available.';
const TRANSLATION_NOT_AVAILABLE_TEXT = 'Translation is not available.';

module.exports = {
	DEFAULT_LOCALE_CODE,
	GOLD_COMPANY_ID,
	GOLD_COPY_NOT_AVAILABLE_TEXT,
	TRANSLATION_NOT_AVAILABLE_TEXT
};